import { RoughNotation } from 'react-rough-notation';
import { useState } from 'react';
import { colors } from '#utils';

const Underline = ({
    children,
    color = 'yellow',
    show = true,
    animate = true,
    animationDelay = 0,
    animationDuration = 2000,
    strokeWidth = 2,
    padding = 0,
    iterations = 3,
    hoverAction = true,
    ...props
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const currentColor = colors[color]?.[isHovered ? 'hover' : 'base'] || color || '#ff0000';

    return (
        <RoughNotation
            type="underline"
            show={show}
            animate={animate}
            animationDelay={animationDelay}
            animationDuration={animationDuration}
            strokeWidth={strokeWidth}
            color={currentColor}
            padding={padding}
            iterations={iterations}
            {...props}
            onMouseEnter={() =>
                hoverAction ? setIsHovered(true) : null
            }
            onMouseLeave={() =>
                hoverAction ? setIsHovered(false) : null
            }
        >
            {children}
        </RoughNotation>
    );
};

export default Underline;
